import Vue from 'vue'
import VueI18n from 'vue-i18n'

// 导入语言文件
import en from './locales/en'
import zh from './locales/zh'
import ja from './locales/ja'

Vue.use(VueI18n)

// 检测浏览器语言
const browserLang = navigator.language || navigator.userLanguage
const defaultLang = browserLang.includes('zh') ? 'zh' : browserLang.includes('ja') ? 'ja' : 'en'

const i18n = new VueI18n({
  locale: localStorage.getItem('lang') || defaultLang, // 从localStorage获取语言设置，默认为浏览器语言
  fallbackLocale: 'en',
  messages: {
    en,
    zh,
    ja
  }
})

export default i18n
